import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { AnalyticsUrlParams, createWebTracker, } from 'analytics-client';
import { createContext, useContext, useReducer } from 'react';
export var AnalyticsStoreActions;
(function (AnalyticsStoreActions) {
    AnalyticsStoreActions["setAnalyticsData"] = "set_analytics_data";
})(AnalyticsStoreActions || (AnalyticsStoreActions = {}));
var AnalyticsStateContext = createContext(undefined);
var initialContext = {
    analyticsClient: null,
    webTracker: null,
    urlParamsHandler: null,
    trackBalenaNavigation: function (url) { return url; },
};
var contextReducer = function (state, _a) {
    var _b;
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case AnalyticsStoreActions.setAnalyticsData: {
            if (!payload || state.analyticsClient) {
                return state;
            }
            var urlParamsHandler_1 = new AnalyticsUrlParams();
            var trackBalenaNavigation = function (url) {
                var baseUrl = new URL(url);
                var deviceIdQuery = urlParamsHandler_1.getQueryString(baseUrl);
                if (!baseUrl.search) {
                    baseUrl.search = deviceIdQuery;
                }
                else {
                    baseUrl.search = baseUrl.search + "&".concat(deviceIdQuery);
                }
                return baseUrl.toString();
            };
            var newQuery = (_b = urlParamsHandler_1.consumeUrlParameters(window.location.search)) !== null && _b !== void 0 ? _b : null;
            if (newQuery != null) {
                var newUrl = window.location.pathname + (!!newQuery ? "?".concat(newQuery) : '');
                window.history.replaceState(null, '', newUrl);
            }
            var analyticsClient = payload.createAnalyticsClient(urlParamsHandler_1);
            var webTracker = analyticsClient && payload && 'trackerName' in payload
                ? createWebTracker(analyticsClient, payload.trackerName)
                : null;
            if (analyticsClient) {
                urlParamsHandler_1.setClient(analyticsClient);
            }
            return __assign(__assign({}, state), { analyticsClient: analyticsClient, webTracker: webTracker, urlParamsHandler: urlParamsHandler_1, trackBalenaNavigation: trackBalenaNavigation });
        }
        default: {
            throw new Error("Unhandled action type: ".concat(type));
        }
    }
};
export var AnalyticsContextProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(contextReducer, initialContext), state = _b[0], dispatch = _b[1];
    var value = { state: state, dispatch: dispatch };
    return (_jsx(AnalyticsStateContext.Provider, __assign({ value: value }, { children: children })));
};
export var useAnalyticsContext = function () {
    var context = useContext(AnalyticsStateContext);
    if (context === undefined) {
        throw new Error('useAnalyticsContext must be used within a ContextProvider');
    }
    return context;
};
